import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule, ModalController } from '@ionic/angular';
import { NgxTippyModule } from 'ngx-tippy-wrapper';

import { MessageService } from 'src/services/message.service';
import { SlackService } from 'src/services/slack.service';

@Component({
  selector: 'app-create-slack-user-group-modal',
  templateUrl: './create-slack-user-group-modal.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, NgxTippyModule],
})
export class CreateSlackUserGroupModalComponent implements OnInit {
  @Input() userGroupId: string;
  @Input() userGroupName: string;
  @Input() userGroupDescription: string;
  @Input() connectionId: string;

  isLoading = false;
  name: string = '';
  description: string = '';
  handle: string = '';
  MAX_LENGTH = 21;

  constructor(
    private modalCtrl: ModalController,
    private msgSrvc: MessageService,
    private slackService: SlackService,
  ) {}

  ngOnInit() {
    // Pre-populate fields with user group data
    this.name = this.userGroupName || '';
    this.description = this.userGroupDescription || '';
  }

  canSubmit(): boolean {
    return !!(
      this.name?.trim() &&
      this.handle?.trim() &&
      this.name.length <= this.MAX_LENGTH &&
      this.handle.length <= this.MAX_LENGTH &&
      this.userGroupId
    );
  }

  async submit() {
    if (!this.canSubmit()) {
      await this.msgSrvc.show('Please fill in all required fields.');
      return;
    }

    this.isLoading = true;

    try {
      const result = await this.slackService.createSlackUserGroup(
        this.name.trim(),
        this.description?.trim() || '',
        this.handle.trim(),
        this.connectionId,
        this.userGroupId,
      );

      this.modalCtrl.dismiss({ success: true, usergroup: result });
    } catch (error) {
      // Show error but keep modal open for retry
      await this.msgSrvc.showError(error);
    } finally {
      this.isLoading = false;
    }
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }
}
